//
// Module for the Age Rate Tables Index view
//
rs.module("content/system_/configuration/ageratetables/index",

    [
        "controls/data/grid",
        "controls/components/event-banner"
    ],

    function (gridModule, eventBanner) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {

            var filter = $.js(jsSelectors.filter);

            var filterIndicators = filter.js(jsSelectors.filterIndicators);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            filterIndicators.find("input").on('click', function () {

                loadingSpinner.show();

                // Update grid, set row selection, update detail of selected row
                gridModule.update(
                    backendUrl,
                    { showAll: this.value },
                    lrsGridApi.agGridApi,
                    function done() {
                        loadingSpinner.hide();
                        eventBanner.removeAllMessages();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);